import React from "react";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";

export const ipAddressPattern = {
  value: /^((25[0-5]|(2[0-4]|1\d|[1-9]|)\d)\.?\b){4}$/,
  message: (<TranslationWrapper tKey={"Must be a valid ip-address, for example: 192.168.0.15"} />) as unknown as string,
};
